 
 <div style="padding-top: 40px;">
<table style="width: 80%; margin-left: 10%; ">
   
    <!-- <tr>
        <td> 
            <div class="mat-elevation-z8">
                <div class="card">
                <a routerLink="/createcontest"><h4>
                    <span class="glyphicon glyphicon-plus"></span>  Create Contest</h4></a> 
            </div>
        </div>
        </td>  
    </tr> -->
    <tr>
        <td> <div class="mat-elevation-z8"> 
            <div class="card">
           <a routerLink="/bankaccount"><h4><span class="glyphicon glyphicon-piggy-bank"></span>  Bank Account</h4></a> 
       </div> </div>
   </td>
</tr>
<!-- <tr>
        <td>  <div class="mat-elevation-z8"> 
            <div class="card">
                <a routerLink="/deposit"><h4><span class="glyphicon glyphicon-asterisk"></span>  Deposit</h4></a> 
            </div></div>
        </td>
     
      
    </tr> -->
    <tr>    
             <td>  <div class="mat-elevation-z8">  
        <div class="card">
        <a routerLink="/howtoplay"><h4><span class="glyphicon glyphicon-book"></span>  How To Play</h4></a> 
    </div> </div>
</td>    </tr>
<!-- <tr>
        <td> 
            <div class="mat-elevation-z8">
                <div class="card">
                <a routerLink="/settings"><h4><span class="glyphicon glyphicon-cog"></span> Settings</h4></a> 
            </div>
        </div>
        </td>   
     </tr> --> 
        <tr>
        <td>  <div class="mat-elevation-z8"> 
            <div class="card">
            <a routerLink="/support"><h4><span class="glyphicon glyphicon-headphones"></span>  Support</h4></a> 
        </div> </div>
    </td>
 
     <!-- <td>  <div class="mat-elevation-z8"> 
            <div class="card">
                <a routerLink="/promotions"><h4><span class="glyphicon glyphicon-fire"></span>  Promotions</h4></a> 
            </div></div>
        </td> -->
       
    </tr>
    
</table></div>